import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireActiveSubscription } from '@/lib/middleware'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination',
)({
  beforeLoad: async ({ location }) =>
    requireActiveSubscription(location.pathname),
  component: () => <Outlet />,
})
